

export default function() {
  return [
    /*  {
      title: "Bestellingen",
      to: "/bestellingen",
      htmlBefore: 'shopping-cart',
      htmlAfter: ""
    }, */
    {
      title: "Bestellingen",
      to: "/producten",
      htmlBefore: 'https://firebasestorage.googleapis.com/v0/b/web-app-bbo-prod.appspot.com/o/systeem-foto%2Flabel.svg?alt=media&token=94da3c67-cc4f-48bc-8e83-181c2d1369f2',
      htmlAfter: ""
    }, 
    
  ];
}
